import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../Hyperlink';
import styles from './page_nav_layout.module.scss';

export const PageNavLayout: FC = ({ children }) => {
  const source = 'entity-nav';
  return (
    <>
      <div className={styles.title}>
        <FormattedMessage id="components/page-nav/PageNavLayout.tsx/1" />
      </div>
      <div className={styles.content}>{children}</div>
      <div className={styles.footer}>
        <Hyperlink href="/a-propos" source={source}>
          <FormattedMessage id="components/page-nav/PageNavLayout.tsx/2" />
        </Hyperlink>
        <Hyperlink href="/aide" source={source}>
          <FormattedMessage id="components/page-nav/PageNavLayout.tsx/3" />
        </Hyperlink>
        <Hyperlink href="/cgu" source={source}>
          <FormattedMessage id="components/page-nav/PageNavLayout.tsx/4" />
        </Hyperlink>
      </div>
    </>
  );
};
